<template>
  <v-select
    v-model="selectedItem"
    class="pl-4"
    :class="{ 'primary darken-1': !disabled, 'secondary lighten-3': disabled }"
    :disabled="disabled"
    hide-details
    outlined
    single-line
    :label="label"
    :items="dropdownOptions"
    :item-text="itemText"
    :item-value="itemValue"
    :multiple="multiple"
    :menu-props="{
      offsetY: true,
      bottom: true,
      nudgeLeft: '12px'
    }"
  >
    <!-- TODO: fix appended icon not clickable. Possible issue here: https://github.com/vuetifyjs/vuetify/issues/12713 -->
    <template v-slot:append>
      <v-btn fab depressed x-small color="transparent" class="disable-hover-bg" :ripple="false"><v-icon color="white" class="transparent">mdi-chevron-down</v-icon></v-btn>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: { required: true },
    disabled: { type: Boolean, default: false },
    label: { default: 'Select' },
    dropdownOptions: { type: Array, required: true },
    itemText: { type: String, required: false },
    itemValue: { type: String, required: false },
    multiple: { type: Boolean, default: false }
  },
  data: () => ({ item: null }),
  mounted() {
    for (let slot in this.$scopedSlots) {
      if (slot == 'item') this.item = slot
    }
  },
  computed: {
    selectedItem: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
  .v-label,
  input,
  .v-select__selection {
    color: white;
  }

  .v-label {
    background-color: transparent;
  }

  fieldset {
    color: transparent !important;
  }

  .v-input__append-inner {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
}
</style>
